import React, {Component, Fragment, h} from "preact";
import {AppPage} from "../_common/components/app-page";
import {connect} from "react-redux";
import {t} from '../_i18n';
import {C, Card, CF, E, F, FR, R} from "../_common/layout";
import {CompanyCompany, CompanyOffer} from "../_api";
import {fetchBusinessSectors, fetchCompany, saveCompany, uploadCompanyLogo} from "../_rx/jobs/actions";
import { Form as FinalForm} from "react-final-form";
import {
    FormField, FormFieldSelect,
    FormFieldTextArea, isValidDniInForm, SubmitButtonRow, validateString
} from "../_common/forms/components/components";
import {isValidDni, rndStr} from "../_common/common";
import {JSXInternal} from "preact/src/jsx";
import TargetedEvent = JSXInternal.TargetedEvent;
import {Redirect} from "react-router-dom";
import {showErrorClosed} from "../offerEdit/validateOfferEdit";
import {toastService} from "../_services/toast-service";
import {COMPANY_DATA_TITLE, COMPANY_DATA_TITLE_PAGE} from "../constants";
import {Helmet} from "react-helmet";
const ValidateYoutube = (url:string)=>{
    if(!url) return; // es opcional
    const re = /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+$/;
    return !url.match(re); // las validaciones de FinalForm han de devolver "truthy" cuando hay error
}

const validateWeb = (text:any, vallValues:any, meta:any) => {
    const textHaveHttp = text?.indexOf('http://') !== -1;
    const textHaveHttps = text?.indexOf('https://') !== -1;

    return !(textHaveHttp || textHaveHttps || text === '' || text === undefined);

}


class View extends Component<Props,{loading:boolean}> {

    id = rndStr();
    logoBase = window.env.JOBS_API_basePath;

    componentDidMount() {
        // se fuerza siempre el cargado del company
        this.props.fetchCompany();
        if(!this.props.business_sectors_kn)
            this.props.fetchBusinessSectors();
    }

    async onSubmit(company: CompanyCompany){
        await this.props.saveCompany(company);
        this.props.history.goBack()
    }

    async fileChanged(e:TargetedEvent<HTMLInputElement,Event>){
        try {
            this.setState({loading: true});
            const files = (e.target as HTMLInputElement).files as any;
            const newImage = files[0];
            await this.props.uploadCompanyLogo(newImage);
        }catch(e: any){
            const error = await e.json()
            toastService.showToast({message: error.msg, type:'danger'});
        }finally {
            this.setState({loading: false});
        }
    }


    render({company, history, business_sectors_kn}: Props) {
        if(!company || !business_sectors_kn) return null;

        return (
            <Fragment>
                <Helmet>
                    <title>{COMPANY_DATA_TITLE_PAGE}</title>
                </Helmet>
                <FinalForm
                onSubmit={(data:CompanyOffer)=>this.onSubmit(data)} initialValues={company}
                render={({handleSubmit,  submitting, values, pristine, submitSucceeded, submitFailed}:any)=>
                    <form className='form' action="" onSubmit={handleSubmit}  noValidate><F className='max-width-780'>
                        {submitSucceeded && <Redirect to={`/offers`} />}
                        {submitFailed && setTimeout(() => {
                            const el = document.querySelector('.form-group.error');
                            el && el.scrollIntoView({ behavior: 'smooth' })
                        })}

                        {company && <Fragment>
                            <C>
                                <Card>
                                    <h2 className="m-bottom">Logo</h2>
                                    <div className="d-iblock">
                                        <div className="card image-squared" style={`background-image:url('${this.logoBase}/company/view-logo/${company.logo}');`} />
                                    </div>
                                    <label for={this.id} className="d-iblock m-lr cursor-pointer text-info">Actualizar
                                        <input
                                            id={this.id}
                                            type="file"
                                            accept="image/*"
                                            className="d-none"
                                            onChange={e => this.fileChanged(e)}
                                            onClick={(event: any) => {event.target.value = null}}
                                        />
                                    </label>

                                    <hr className="separator-xxs"/>

                                    <h2 className="m-bottom">Información de la empresa</h2>

                                    <FR>
                                        <div className="sm-col-80 col-100">
                                            <FormField label={'Nombre'} name="name" required />
                                        </div>
                                    </FR>
                                    <FR>
                                        <div className="sm-col-80 col-100">
                                            <FormFieldSelect label={'Sector de la empresa'} name="subtitle" options={business_sectors_kn} required />
                                        </div>
                                    </FR>
                                    <FR>
                                        <div className="sm-col-80 col-100">
                                            <FormField label={'Sector de la empresa a mostrar'} name="sector" />
                                        </div>
                                    </FR>
                                    <FR>
                                        <div className="sm-col-25 col-100">
                                            <FormField label={'Nº de trabajadores'} name="empleados" type="number" required />
                                        </div>
                                    </FR>

                                    <FormFieldTextArea label={'Descripción de tu empresa'} rows={10} name="text" required />

                                    <FR>
                                        <div className="sm-col-80 col-100">
                                            <FormField label={'Población'} name="location" required />
                                        </div>
                                    </FR>

                                    <hr className="separator-xxs"/>

                                    <h2 className="m-bottom">Otros datos</h2>

                                    <FR>
                                        <div className="sm-col-80 col-100">
                                            <FormField label={'Página web'} name="web" validate={validateWeb} specificError={t('Parece que el formato de la web es incorrecto.')} placeholder={'https://website.com'}/>
                                        </div>
                                        <div className="sm-col-80 col-100 p-bottom">
                                            <FormField label={'Vídeo promocional en youtube'} name="video" validate={ValidateYoutube} specificError={t('Parece que el formato del video es incorrecto.')}/>
                                        </div>
                                    </FR>
                                </Card>

                                <SubmitButtonRow disabled={submitting || this.state.loading} onCancel={()=>history.goBack()}/>
                            </C>
                        </Fragment>}
                    </F>
                    </form>}/>
            </Fragment>
        );
    }
}

type Props = {company:CompanyCompany, fetchCompany: typeof fetchCompany, saveCompany:typeof saveCompany, uploadCompanyLogo: typeof uploadCompanyLogo, history: any, business_sectors_kn: [{keys:string, name:string}], fetchBusinessSectors: typeof fetchBusinessSectors};

const ConnectedView: any = connect(
    ({company, fixtures: {business_sectors_kn}}: any)=>({company, business_sectors_kn}), {fetchCompany, saveCompany, uploadCompanyLogo, fetchBusinessSectors})(View as any);

export default ({history}:any) =>
    <AppPage
        name="company-edit"
        title={t(COMPANY_DATA_TITLE)}
        back={() => {history.goBack()}}
        subtitle=""
        className="max-width-780">
        <ConnectedView history={history} />
    </AppPage>
;

